import { Injectable } from '@angular/core';
import { HttpEvent,HttpInterceptor,HttpHandler,HttpRequest } from '@angular/common/http'; 
import { Observable } from 'rxjs';
import { AppService } from '../app/app.service';

@Injectable()
export class Authinterceptor implements HttpInterceptor{
  
    constructor(private service:AppService){}
    intercept(req:HttpRequest<any>,next:HttpHandler): Observable<HttpEvent<any>>{
      
      if(this.service.isLoggedIn()){
        const authReq=req.clone({setHeaders:{Token:this.service.getAuthorizationToken(),Type:'Web'}});
        return next.handle(authReq);
      }
      return next.handle(req);
    }
}